import * as IpAddress from 'ip-address';

export enum HostType {
    internet = 'IP Address', // INTERNET
    hostName = 'Hostname', // HOSTNAME
    ethernet = 'Mac Address', // (appears on its own in the license)
    internetx3 = 'IP Address x3', // INTERNET
    hostNamex3 = 'Hostname x3', // HOSTNAME
    ethernetx3 = 'Mac Address x3', // (appears on its own in the license)
    userName = 'User name', // USER
    na = 'N/A'
}

export enum RemoteHostType {
    HOSTNAME = 'HOSTNAME',
    INTERNET = 'INTERNET',
    USER = 'USER'
}

export function getLicenseStringForHost(hostType: HostType, hostId: string) {
    // there is no need for  case HostType.ethernetx3, case HostType.hostNamex3 and case HostType.internetx3
    // because these can't be selected
    switch (hostType) {
        case HostType.ethernet:
            return hostId;
        case HostType.hostName:
            return RemoteHostType.HOSTNAME + "=" + hostId;
        case HostType.internet:
            return RemoteHostType.INTERNET + "=" + hostId;
        case HostType.userName:
            return RemoteHostType.USER + "=" + hostId;
    }
}

const hostTypeMap = new Map<RemoteHostType, HostType>();
hostTypeMap.set(RemoteHostType.HOSTNAME, HostType.hostName);
hostTypeMap.set(RemoteHostType.INTERNET, HostType.internet);
hostTypeMap.set(RemoteHostType.USER, HostType.userName);

export function splitHostString(host: string) {
    const indexOfEquals = host.indexOf('=');
    let hostType : HostType;
    let hostId = '';
    if (indexOfEquals === -1) {
        // ethernet
        hostType = HostType.ethernet;
        hostId = host;
    } else {
        const remoteHostType = host.substring(0, indexOfEquals) as RemoteHostType;
        hostType = hostTypeMap.get(remoteHostType)!;
        hostId = host.substring(indexOfEquals + 1);
    }
    return { hostType, hostId }
}

export enum LicenseType {
    server_n_cores = 'Server n Cores',
    server_worldbox = 'Server WorldBox',
    server_boeing = 'Server Boeing',
    server_unlocked = 'Server Unlocked',
    named_user = 'Named User',
    concurrent_operation = 'Concurrent Operation',
    fixed_host_rest = 'Fixed Host REST',
    rest_capacity = 'REST Capacity',
    redistribution = 'Redistribution', //not supporting as it is a key
    concurrent_user_rhienmetal = 'Concurrent User (Rhienmetal)',
    concurrent_server_synopsys = 'Concurrent Server (Synopsys)',
    saas_subscription = 'SaaS Subscription',
    saas_starter_subscription = 'SaaS Starter Subscription',
    trial = 'Trial',
    trialCO = 'Trial (CO)'
}

export enum HostIdValidity {
    valid = 'Valid Host Id',
    invalid = 'Invalid Host Id',
    disallowed = 'Disallowed Host Id',
    valid_ip_address = 'Valid IP Address',
    invalid_ip_address = 'Invalid IP Address',
    duplicate_hostid = 'Duplicate Host Id'
}

export interface ErrorData {
    hostId: string | null,
    hostId2: string | null,
    hostId3: string | null,
    port: string | null
}

const regexForMacAddresses = "^([0-9a-fA-F][0-9a-fA-F]){6}$";

export const initializeHostIdHelperText = (hostType: HostType) => {
    let helperText: string = hostType === ("" as HostType) ? "Select Host Type" : "Enter " + hostType;
    return helperText;
}

const isIdUnique = (allIds: string[], id: string,) => {
    return allIds.indexOf(id) === allIds.lastIndexOf(id);
}

export function validateHostId(hostTypeArg: HostType, hostIdArg: string, allHostIds: string[], checkDuplicates: boolean = true) {
    let hostIdValidityResult: string | null = null;
    hostIdArg = hostIdArg.trim();
    if (hostIdArg === "" || hostTypeArg === ("" as HostType)) {
        hostIdValidityResult = initializeHostIdHelperText(hostTypeArg);
    } else {
        switch (hostTypeArg) {
            case HostType.hostName:
            case HostType.hostNamex3:
                if (hostIdArg === "localhost") {
                    hostIdValidityResult = HostIdValidity.disallowed;
                }
                break;
            case HostType.ethernet:
            case HostType.ethernetx3:
                if (!(hostIdArg.match(regexForMacAddresses))) {
                    hostIdValidityResult = HostIdValidity.invalid;
                }
                break;
            case HostType.internet:
            case HostType.internetx3:
                if (!(IpAddress.Address4.isValid(hostIdArg) || IpAddress.Address6.isValid(hostIdArg))) {
                    hostIdValidityResult = HostIdValidity.invalid_ip_address;
                } else if ((hostIdArg === '127.0.0.1') || (hostIdArg === '::1/128') || (hostIdArg === '169.254.0.0/16') || (hostIdArg === 'fe80::/10')) {
                    hostIdValidityResult = HostIdValidity.disallowed;
                }
                break;
            case HostType.userName:
                if ((hostIdArg === "root") || (hostIdArg === "administrator") || (hostIdArg === "httpd")) {
                    hostIdValidityResult = HostIdValidity.disallowed;
                }
                if (hostIdArg.indexOf(' ') >= 0) {
                    hostIdValidityResult = HostIdValidity.invalid + "-whitespace not allowed";
                }
                break;
        }
        //if (triadCompatible && !disableThreeServerRedundancy && isIdUnique(allHostIds, hostIdArg)) {
        if (checkDuplicates && !isIdUnique(allHostIds, hostIdArg)) {
            hostIdValidityResult = HostIdValidity.duplicate_hostid;
        }
    }
    return hostIdValidityResult;
}
